<template>
    <AppHead title="Welcome | 10xTravel+" />
    <div class="min-h-screen bg-slate-50 dark:bg-slate-900/40">
        <!-- Logo -->
        <div class="flex justify-center pt-8 pb-16">
            <img src="/images/logo.svg" alt="MY10x" class="h-8" />
        </div>

        <!-- Success Card -->
        <div class="max-w-lg mx-auto px-4 md:px-6">
            <div
                class="bg-white dark:bg-slate-800 rounded-2xl border border-slate-200 dark:border-slate-700 shadow-sm px-6 md:px-8 py-12 md:py-16 flex flex-col items-center text-center"
            >
                <!-- Green Checkmark -->
                <div
                    class="w-20 h-20 rounded-full bg-emerald-400 flex items-center justify-center mb-8"
                >
                    <svg
                        class="w-10 h-10 text-white"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                </div>

                <!-- Heading -->
                <h1 class="text-3xl font-semibold text-slate-800 dark:text-slate-100 mb-3">
                    Welcome to 10xTravel+
                </h1>
                <p class="text-base text-slate-500 dark:text-slate-400 max-w-sm mb-10">
                    Your subscription begins now with all new features unlocked.
                </p>

                <!-- CTA Button -->
                <Link
                    href="/10xtravel-plus"
                    class="w-full max-w-sm bg-orange text-white text-base font-medium py-3.5 px-6 rounded shadow-sm hover:bg-orange-dark transition-colors text-center"
                >
                    Explore 10xTravel+
                </Link>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { Link } from '@inertiajs/vue3';
import AppHead from '@/Partials/AppHead.vue';
import Plain from '@/Layouts/Plain.vue';

defineOptions({ layout: Plain });

onMounted(() => {
    axios.get('/api/travel-plus/subscription/status').catch(() => {});
});
</script>
